export const useObservationEvents = () => {
  return true;
};
